/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LabControllerGetSupportedLanguages$Params {
  labId: string;
}

export function labControllerGetSupportedLanguages(http: HttpClient, rootUrl: string, params: LabControllerGetSupportedLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, labControllerGetSupportedLanguages.PATH, 'get');
  if (params) {
    rb.path('labId', params.labId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

labControllerGetSupportedLanguages.PATH = '/lab/{labId}/supportedLanguages';
